import { FieldGroup, TextArea } from '../components/form';
import type { Draft } from './draft';

export function StepNotes({ draft, onChange }: { draft: Draft; onChange: (next: Draft) => void }) {
  return (
    <FieldGroup
      title="Special instructions"
      description="Anything IT should know that the sections above do not cover: section 7 of the paper form."
    >
      <div className="max-w-2xl">
        <TextArea
          label="Notes"
          rows={8}
          value={draft.specialInstructions}
          onChange={(value) => onChange({ ...draft, specialInstructions: value })}
          maxLength={4000}
          placeholder="For example: starting at Kombat before moving to the office, needs the laptop ready a week early, shares a desk with someone on rotation."
        />
        <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">
          {draft.specialInstructions.length} of 4000 characters. Optional.
        </p>
      </div>
    </FieldGroup>
  );
}
